'use strict';

let MemberApp = angular.module('MemberApp');

MemberApp.controller('UnauthenticatedCtrl', function(
  $scope,
  userStore) {

  this.justLoggedOut = function() {
    return userStore.getRecentlyLoggedOut();
  };

});
